export default __webpack_public_path__ + "static/media/arrowUp.86866f2e.svg";